import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})

export class ConfirmationPopupComponent {
  @Input() message: any;
  @Input() header: any;
  @Input() lableName: any;
  @Input() lableCancel: any;
  @Input() isConfirmationMessage: boolean = false;
  @Input() isConfirmationMessageRequired: boolean = false;
  @Input() showDropdown: boolean = false;
  @Input() showInput: boolean = false;
  @Input() isDropdownSelectionReqired : boolean = false
  @Input() dropdownOptions: { label: string, value: any }[] = [];
  @Input() showQuestionMark: boolean = true;
  @Input() showCancelButton: boolean = true;
  @Input() showCloseButton: boolean = true;
  @Input() numberFormat: any;
  @Input() documentNumber: string = '';
  @Output() newFolderName: EventEmitter<any> = new EventEmitter();
  metaDataForm: FormGroup;

  reason: FormControl<any> = new FormControl('');

  dropDownController: FormControl<any> = new FormControl('');
  documentNumberControl: FormControl<string> = new FormControl();

  documentNumberForm: any[] = [];
  daysMonths: any[] = Array.from({length: 31}, (_, i) => (i+1).toString().padStart(2, '0'));
  prasentYear: number = new Date().getFullYear();
  ddmmyyyyy: string = new Date().toISOString().slice(0, 10);
  ddmmyy: string = new Date().toISOString().slice(0, 10);
  initialDocumentNumber: string = '';

  constructor(
    public activeModal: NgbActiveModal) { }

  ngOnInit() {
    if (this.metaDataForm && this.documentNumberForm?.length) {
      // Assume only one document number field for simplicity
      const docNumField = this.documentNumberForm[0]?._id;
      if (docNumField && this.metaDataForm.get(docNumField)) {
        this.initialDocumentNumber = this.metaDataForm.get(docNumField)?.value || '';
      }
    }
    if (this.documentNumber) {
      this.initialDocumentNumber = this.documentNumber;
    }
  }

  successClose() {
    if (this.isConfirmationMessage) {
      this.activeModal.close({
        reason: this.reason.value,
        isClose: true,
        documentNumber: this.documentNumberControl.value
      });
    } else if (this.showDropdown) {
      this.activeModal.close({
        reason: this.dropDownController.value === 'Other' ? this.reason.value : this.dropDownController.value,
        isClose: true
      })
    }
    else if (this.showInput && this.metaDataForm && this.documentNumberForm?.length) {
      let currentValue : any = [];
      this.documentNumberForm.forEach((field: any) => {
        currentValue.push(this.metaDataForm.get(field._id)?.value);
      })
      this.activeModal.close({
        isClose: true,
        documentNumber: currentValue
      });
    }
    else {
      this.activeModal.close(true)
    }
  }

  get formattedMessage(): string {
    return this.message + (this.showQuestionMark ? '?' : '');
  }

}
